import { AXButtonModule } from '@acorex/components/button';
import { AXDecoratorModule } from '@acorex/components/decorators';
import { AXDrawerModule } from '@acorex/components/drawer';
import { AXDropdownModule } from '@acorex/components/dropdown';
import { AXMenuModule } from '@acorex/components/menu';
import { AXBasePageComponent } from '@acorex/components/page';
import { AXPopupService } from '@acorex/components/popup';
import { AXSwitchModule } from '@acorex/components/switch';
import { AXEventService } from '@acorex/core/events';
import { AXTranslationModule, AXTranslationService } from '@acorex/core/translation';
import { CommonModule, Location } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewEncapsulation, afterNextRender, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { PublicLoginComponent, PublicLoginService } from '@travel/public-login';
import { SettingDataOutputModel, UserProfileOutputModel } from '@travel/shared';
import { DataConfig, PlatformService, SharedService, StorageService, ThemeService } from '@travel/shared/services';

@Component({
  selector: 'travel-btc-workspace-drawer-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, AXButtonModule, AXDropdownModule, AXDecoratorModule, AXTranslationModule, AXMenuModule, AXDrawerModule, AXSwitchModule, FormsModule],
  templateUrl: './hotel-wl-drawer-menu.component.html',
  styleUrls: ['./hotel-wl-drawer-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DrawerMenuComponent extends AXBasePageComponent {
  protected translateService = inject(AXTranslationService);

  eventService: AXEventService = inject(AXEventService);

  userProfile: UserProfileOutputModel = {};

  walletBalanceWl: any = {};
  walletId: any;
  showWallet = false;

  HeaderType: 'main' | 'child' = 'main';
  languageId: any;
  isMobile = false;
  language: string;
  selectedLanguage!: string;

  env: string = this.environment.picturesURL;

  settingData: SettingDataOutputModel = DataConfig.get('globalSetting');

  languageList: any[] = [
    {
      code: 'fa',
      title: 'فارسی',
    },
    {
      code: 'en',
      title: 'English',
    },
    {
      code: 'ar',
      title: 'العربية',
    },
  ];
  headerMenuItemList: any[] = [];
  private _axConfig: any;
  e: any;
  constructor(
    private _popupService: AXPopupService,
    protected storageService: StorageService,
    private _router: Router,
    protected themeService: ThemeService,
    protected _platfromService: PlatformService,
    private _publicLoginService: PublicLoginService,
    private _sharedService: SharedService,
    private location: Location,
    @Inject('AppConfigService') axConfig: any,

    @Inject(PLATFORM_ID) private platformId: object,
    @Inject('environment') private environment: any
  ) {
    super();
    // this.userProfile = storageService.get('USER_PROFILE');

    this._axConfig = axConfig;
    this.isMobile = this._platfromService.isPlatform() || false;
    this.language = _platfromService.siteLanguage();
    
    afterNextRender(()=>{
      this.setMenuItem()

    })
  }

  async setMenuItem(){
    this.headerMenuItemList = [
      {
        id: 0,
        code: 'reserve-list',
        // text: 'رزروهای من',
        text:await this.translateService.translateAsync('header.reservationsList'),
        icon: 'fa-solid fa-file-lines',
        active: false,
        path: this._platfromService.siteLanguage() + '/account/reservations',
      },
      {
        id: 1,
        code: 'profile',
        // text: 'اطلاعات پروفایل',
        text:await this.translateService.translateAsync('profile.informationProfile'),
        icon: 'fa-solid fa-user',
        active: false,
        divider: true,
        path: this._platfromService.siteLanguage() + '/account/account-info',
      },
    ]
  }


  override ngOnInit(): void {
    // this.languageList = this.settingData.whiteLabelId !== 953 ? this.languageList.filter((x) => x.code != 'fa') : this.languageList;
    this._publicLoginService.currentUser.subscribe((loggedIn) => {
      this.userProfile = loggedIn;
    });
    if (this.settingData.paymentTypeId.findIndex((e: any) => e.id === 2) !== -1) {
      this.showWallet = true;
      this.walletInfo();
    }

    // this._loginService.loggedIn$.subscribe((loggedIn) => {
    //   this.userProfile = loggedIn;
    // });
  }

  _handleOnItemClick(event: any) {
    switch (event.code) {
      case 'profile':
        this._router.navigate([this._platfromService.siteLanguage() + '/account/account-info']);
        break;
      case 'reserve-list':
        this._router.navigate([this._platfromService.siteLanguage() + '/account/reservations']);
        break;
      case 'account':
        if (this.isMobile) {
          this._router.navigate([this._platfromService.siteLanguage() + '/account']);
        }
        break;
      case 'logout':
        this.storageService.remove('USER_PROFILE');
        this.userProfile = this.storageService.get('USER_PROFILE');
        this.location.replaceState(this._platfromService.siteLanguage());
        document.location.reload();
        break;
      case 'fa':
        this.selectedLanguage = 'Fa';
        this.location.replaceState('/fa');
        this._axConfig.load();
        document.location.reload();
        break;
      case 'en':
        this.selectedLanguage = 'En';

        this.location.replaceState('/en');
        this._axConfig.load();
        document.location.reload();

        break;
      case 'ar':
        this.selectedLanguage = 'Ar';
        this.location.replaceState('/ar');
        this._axConfig.load();
        document.location.reload();
        break;
      default:
        break;
    }
  }

  // لاگین
  loginPopup() {
    this._popupService
      .open(PublicLoginComponent, {
        // ورود به حساب کاربری
        title: this.translateService.translateSync('profile.loginForm'),
        size: 'sm',
      })
      .then((isLogin) => {
        if (isLogin) {
          this.userProfile = this.storageService.get('USER_PROFILE');
        }
      });
  }

  // دریافت اطلاعات کیف پول کاربر جاری سیستم
  async walletInfo() {
    const walletInfoObj = {
      hotelId: null,
      agencyId: this.settingData.agencyId,
      guestProfileId: this.userProfile.userAccountId,
      walletTypeId: 1,
    };

    if (!this.isLoading) {
      this.isLoading = true;
    }

    this._sharedService
      .getWalletInfo(walletInfoObj)
      .then((res: any) => {
        this.walletId = res;
        this.getWalletBalance();
      })
      .finally(() => (this.isLoading = false));
  }

  // دریافت موجودی
  getWalletBalance() {
    if (!this.isLoading) {
      this.isLoading = true;
    }
    this._sharedService
      .getWalletBalance(this.walletId)
      .then((res: any) => {
        this.walletBalanceWl = res;
      })
      .finally(() => (this.isLoading = false));
  }

  //خروج از حساب کاربری
  onHndleLogOut() {
    this.storageService.remove('USER_PROFILE');
    this.userProfile = this.storageService.get('USER_PROFILE');
    this.location.replaceState(this._platfromService.siteLanguage());
    document.location.reload();
  }
}
